import { Controller } from '@hotwired/stimulus'
import Toast from 'libs/toast'

export default class extends Controller {
  connect() {
    this.#toggleFilters()
  }

  #toggleFilters() {
    const hasCheckedFilters = document.querySelectorAll('#search-params input:checked').length > 0
    const button = document.querySelector('#search-params-trigger')
    button.classList.toggle('active', hasCheckedFilters)
  }
}

